// extracted by mini-css-extract-plugin
module.exports = {"author":"styles_author__2rfYJ"};